import {apiClient} from '../apiClient';
import {ConceptReportPayload} from '../../components/reports/concept-explorer/FilterHeader';
import {
  ConceptSaveSearchPayload,
  IConceptExplorer,
  IConceptDocListRequest,
} from '../types/conceptExplorer.type';
import BASE_URL from '../../config/env';
const CONCEPT_BASE_URL = `${BASE_URL}/reporting/api/v1/dataanalysisreport`;
const settingsEndpoint = (path: string) =>
  `reporting/api/v1/dataanalysisreport${path}`;

export const getConceptExplorerData = async (payload: IConceptExplorer) => {
  const { data } = await apiClient.get<any>(
    settingsEndpoint('/render-json'),
    { params: payload }
  );
  return data;
};

export const ConceptExploreView = async (payload: any): Promise<string> => {
  const response = await apiClient.post<string>(
    `${CONCEPT_BASE_URL}/concept-explorer/view`,
    payload,
    {
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const postConceptReport = async (payload: ConceptReportPayload) => {
  const {data} = await apiClient.post<any>(
    `${CONCEPT_BASE_URL}/concept-explorer/save`,
    payload
  );
  return data;
};

export const postSaveSearchConceptReport = async (
  payload: ConceptSaveSearchPayload
) => {
  const {data} = await apiClient.post<any>(
    `${CONCEPT_BASE_URL}/save-search`,
    payload
  );
  return data;
};

export const postGenerateClusterSummaryReport = async (
  payload: ConceptSaveSearchPayload
) => {
  const {data} = await apiClient.post<any>(
    `${CONCEPT_BASE_URL}/summary/cluster-report`,
    payload
  );
  return data;
};

export const postConceptDocList = async (
  payload: IConceptDocListRequest
): Promise<number> => {
  const {data} = await apiClient.post<number>(
    settingsEndpoint('/concept-doclist'),
    payload
  );
  return data;
};